export default __webpack_public_path__ + "static/execs-a74f083ccad16a01080ee2a2af734a49.jpg";